import {
	Drawer,
	DrawerBody,
	DrawerHeader,
	DrawerContent,
	DrawerCloseButton,
	Text,
} from "@chakra-ui/react";
import type { Material } from "../../types/material.types";
import MaterialLogTree from "../MaterialLogTree";

type MaterialHistoryDrawerProps = {
	isOpen: boolean;
	onClose: () => void;
	material?: Pick<Material, "label" | "id">;
};

const MaterialHistoryDrawer = ({
	isOpen,
	onClose,
	material,
}: MaterialHistoryDrawerProps) => {
	if (!material) return null;
	return (
		<Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
			<DrawerContent>
				<DrawerCloseButton />
				<DrawerHeader borderBottom="1px solid #E2E8F0">
					<Text fontSize="18px" fontWeight={600}>
						{material.label}
					</Text>
				</DrawerHeader>

				<DrawerBody>
					<MaterialLogTree material={material} />
				</DrawerBody>
			</DrawerContent>
		</Drawer>
	);
};

export default MaterialHistoryDrawer;
